import React from 'react';
import { Phone, Mail, Globe } from 'lucide-react';
const Footer = () => {
  
  return (
  
         <>  
           
      <section id="contact" className="container mx-auto px-4 py-10 bg-blue-50 rounded-2xl shadow-xl mb-12 border-2 border-blue-100">
        <h2 className="text-3xl font-bold text-blue-700 mb-6">📞 Contactez notre équipe</h2>
        <div className="flex flex-col md:flex-row gap-10 items-center">
          <div className="flex-1 space-y-4">
            <div className="flex items-center gap-3">
              <Phone className="text-blue-700" /> <span className="font-semibold">Téléphone :</span>
              <span className="bg-white px-3 py-1 rounded-full shadow text-blue-900 font-bold">	(+225) 27 21 54 46 59 / 07 07 07 86 74</span>
             
            </div>
            <div className="flex items-center gap-3">
              <Mail className="text-blue-700" /> <span className="font-semibold">Email :</span>
              <span className="bg-white px-3 py-1 rounded-full shadow text-blue-900 font-bold">djatervoyage@gmail.com</span>
            </div>
            <div className="flex items-center gap-3">
              <Globe className="text-blue-700" /> <span className="font-semibold">Adresse :</span>
              <span className="bg-white px-3 py-1 rounded-full shadow text-blue-900 font-bold">	Immeuble Baobab au 3e - Notre Dame Treichville (Abidjan)</span>
            </div>
          </div>

        </div>
      </section>

     
      <footer className="bg-gradient-to-r from-blue-800 to-blue-600 text-blue-100 py-8 mt-12 shadow-inner">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
          <div className="font-bold text-xl tracking-wide">Djater Voyage © 2025</div>
          <div className="text-sm">Tous droits réservés | <a href="#contact" className="underline hover:text-yellow-300 transition">Contact</a></div>
        </div>
      </footer>
        </>
  );
};
export default Footer;